import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function PropertyAgreement() {
  const navigate = useNavigate();
  const loggedInUser = localStorage.getItem("loggedInUser");

  useEffect(() => {
    // ✅ Restrict non-admin users
    if (loggedInUser !== "Admin") {
      alert("⛔ Access denied. Only Admin can view Property Agreements.");
      navigate("/HomePage");
    }
  }, [loggedInUser, navigate]);

  return (
    <div className="property-agreement-container">
      <h2 style={{ textAlign: "center", marginTop: "20px" }}>🏨 PROPERTY AGREEMENTS</h2>
      <div style={{ marginTop: "30px", textAlign: "center" }}>
        <p>This section contains all property agreement details and management tools.</p>
      </div>
    </div>
  );
}

export default PropertyAgreement;
